import { render, staticRenderFns } from "./WinnerLotsEditModal.vue?vue&type=template&id=28dd8cad&scoped=true"
import script from "./WinnerLotsEditModal.vue?vue&type=script&lang=js"
export * from "./WinnerLotsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd8cad",
  null
  
)

export default component.exports